const BookedDetailsCard = ({
  children,
  StyledIcon,
  alignIconStart = false,
}: {
  children?: React.ReactNode;
  StyledIcon?: React.FunctionComponent;
  alignIconStart?: boolean;
}) => {
  return (
    <div
      className={`dr-flex dr-p-16 dr-w-full dr-space-x-12  ${
        alignIconStart ? "" : "dr-items-center"
      }`}
    >
      {StyledIcon ? (
        <div className="">
          <StyledIcon />
        </div>
      ) : null}
      <div className="dr-w-full">{children ? children : null}</div>
    </div>
  );
};

export default BookedDetailsCard;
